

export const convertStatus = (status) => {
    let newStatus;
    switch (status) {
        case 'droppingOff':
        case 'dropping_off':
            newStatus = 'Dropping Off';
            break;
        case 'onHold':
        case 'on_hold':
            newStatus = 'On Hold';
            break;
        case 'pickingUp':
        case 'picking_up':
            newStatus = 'Picking Up';
            break;
        default:
            newStatus = status;
            break;
    }
    return newStatus.toUpperCase()
}

